import {
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input
} from '@chakra-ui/react';
import { useField } from 'formik';

const ErrorInput = ({ name, label, mt= 0, isRequired = false, isDisabled = false, ...props }) => {
    const [field, meta] = useField(name);
    return (
        <FormControl isInvalid={meta.touched && meta.error} isRequired={isRequired} isDisabled={isDisabled} mb={4} mt={mt} bg="white" borderRadius={0}>
            <FormLabel htmlFor={name}>{label}</FormLabel>
            <Input {...field} id={name} {...props} />
            <FormErrorMessage>{meta.error}</FormErrorMessage>
        </FormControl>
    );
};

export default ErrorInput;
